import React from 'react';
import ComingSoonPage from './ComingSoonPage';

const SchedulePage = () => {
  return <ComingSoonPage title="Schedule" />;
};

export default SchedulePage;
